export const spacing = 8;
export const baseColors = {
    navy: "#21006e",
    warm_gray: "#f0ece9",
    white: "#ffffff",
    white2: "#efefef",
    cool_gray: "#fbfafd",
    black: "#222222",
    light_black: "rgba(0,0,0,0.54)",
    gray: "#6e6e6e",
    green: "#6eedb8",
    magenta: "#e35afc",
    light_magenta: "#fdf2ff",
    //magenta: "#efefef",
    purple: "#7e67d8",
    light_purple: "rgba(126, 103, 216, 0.3)",
    light_blue: "#a6d3f4",
    cool_blue: "#dbedfb",
    blue: "#3f30a3",
    purple_alt: "#5c4fb0",
    material_purple: "#531f91",
    header_purple: "#33006e",
    background_purple: "#EFEEF9",
    danger_red: "#fc5a5a",
    base_red: "#db3939",
    inactive_gray: "#cccccc",
    warning_yellow: "#fce35a",
    share_email: "#fff",
    share_facebook: "#4267b2",
    share_linkedin: "#0077B5",
    share_twitter: "#38A1F3",
    hover_green: "#8CF2C7",
    hover_danger_red: "#FE6967",
    border_gray: "#e0e0e0",
    medium_gray: "rgba(186,186,186,0.1)",
};
